<template>
    <ul class="sub-menu d-lg-none" v-show='toggle[market.slug]'>
      <li class="level-2" v-if="!market.disable_charts">
        <router-link :to="{ name: `${market.slug}.instruments`}">
          {{ $t('components.main_header.charts') }}
        </router-link>
      </li>

      <li class="level-2" v-if="!market.disable_video_analysis">
        <router-link :to="{ name: `${market.slug}.video_analysis`}">
          {{ $t('components.main_header.video_analysis') }}
        </router-link>
      </li>
     <!--<li class="level-2">
        <a :href="env.calculator_app_url" target="_blank">
          {{ $t('components.main_header.tools') }}
        </a>
      </li>-->
      <hr>
    </ul>
</template>

<script>
export default {
  props: {
    toggle: Array,
    market: Object
  },
  data () {
    return {
      env: {
        calculator_app_url: process.env.VUE_APP_CALCULATOR_APP_URL
      }
    }
  }
}
</script>
